import React, { useState } from "react";
import styles from "./faq.module.css"; // assuming you have styles here
import { CollapsedIcon, Pluse } from "../../../Svg";

const faqData = {
  "Topic 1": [
    {
      question: "Do I need to pay Shipping / Delivery Charges?",
      answer:
        "There are no Shipping/ Delivery Charges within India & for International Orders.",
    },
    {
      question: "What if I need Personal  Assistance and more information about my Purchase?",
      answer:
        "For any assistance, support and information about your purchase,",
      contact: "Kindly Contact/ Whatsapp us on +91 9845540125/ +91 9632429387",
    },
    {
      question: "Are the Shipments Insured and Secured?",
      answer: "Yes, all our shipments are securely packed and insured. Only transit insurance shall be provided by Pavithra Jewels, and it shall be valid only up to the time of acceptance of delivery.",
    },
    {
      question: "Is the Jewellery Certified?",
      answer:
        "Yes, all our Products are certified by BIS ( Bureau of Indian Standards ) with a Hallmark.",
    },
    {
      question: "How long does it take to manufacture sold out products?",
      answer:
        "It takes 25 days to manufacture a new product.",
    },
    {
      question: "Do you accept Custom orders?",
      answer:
        "Yes, we do accept customized orders. For more information on the same",
      contact: " Kindly Contact/ Whatsapp us on +91 9632429387/ +91 9632429387.",
    },
  ],

};

const FAQ = () => {
  const [selectedTopic, setSelectedTopic] = useState("Topic 1");
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleTopicClick = (topic) => {
    setSelectedTopic(topic);
    setExpandedIndex(null); // Reset the expanded question when topic changes
  };

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className={styles.container}>

      <h2>Frequently asked questions</h2>

      {/* FAQ Content */}
      <div className={styles.content}>
        {faqData[selectedTopic].map((item, index) => (
          <div key={index} className={styles.faqItem}>
            <div className={styles.question} onClick={() => handleToggle(index)}>
              {item.question}
              <span>{expandedIndex === index ? <div><CollapsedIcon /></div> : <div className={styles.positive}><Pluse /></div>}</span>
            </div>
            {expandedIndex === index &&
              <div className={styles.answer}>
                {item.answer}
                <br />
                {item.contact}
              </div>

            }
          </div>
        ))}
      </div>

      <div className={styles.mobile_contant}>
        {Object.keys(faqData).map((topic) => (
          <div className={styles.content1}>
            {/* <h2 className={styles.heading}>{topic}</h2> */}
            {faqData[topic].map((item, index) => (
              <div key={index} className={styles.faqItem}>
                <div
                  className={styles.question}
                  onClick={() => handleToggle(index)}
                >
                  {item.question}
                  <span>
                    {expandedIndex === index ? (
                      <div className={styles.nagative}>-</div>
                    ) : (
                      <div className={styles.positive}>+</div>
                    )}
                  </span>
                </div>
                {expandedIndex === index && (
                  <div className={styles.answer}>{item.answer}
                    <br />
                    {item.contact}
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>

  );
};

export default FAQ;
